module.exports = __webpack_public_path__ + "static/media/client-logo-18.b491c03b.jpg";